import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllSocialMediaVisuals = createAsyncThunk(
  "admin/allSocialMediaVisuals",
  async ({page, limit,}, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/social-media-visuals/all?page=${page}&limit=${limit}`, {
        headers: authHeader(),
      });
      return response; 
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleSocialMediaVisuals = createAsyncThunk(
  "admin/singleSocialMediaVisuals",
  async (SocialMediaVisualsId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/social-media-visuals/${SocialMediaVisualsId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addSocialMediaVisuals = createAsyncThunk(
  "admin/addSocialMediaVisuals",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/social-media-visuals/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editSocialMediaVisuals = createAsyncThunk(
  "admin/editSocialMediaVisuals",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/social-media-visuals/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteSocialMediaVisuals = createAsyncThunk(
  "admin/deleteSocialMediaVisuals",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/social-media-visuals/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
const initialState = {};

const SocialMediaVisualsSlice = createSlice({
  name: "SocialMediaVisualsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSocialMediaVisuals.fulfilled, (state, action) => {
      state.socialMediaVisualsData = action.payload.data;
    });
    builder.addCase(getSingleSocialMediaVisuals.fulfilled, (state, action) => {
      state.singleSocialMediaVisualsData = action.payload.data;
    });
  },
});
export default SocialMediaVisualsSlice.reducer;
